export default __webpack_public_path__ + "static/media/update-cam.557bbc36.png";